import {paymentGetters} from "./paymentGetters";
import {paymentMutations} from "./paymentMutations";

export const PAYMENT_STATE = {
    formVisible: false,
    attemptCount: 0,
    validAttemptCount: 0,
    failedCount: 0,
    captchaKey: null,
    captchaValue: null,
    offlineSignup: {enabled: false},
    tncAccepted: false,
    ccEntered: false,
    cvvEntered: false,
    expEntered: false,
    errors: [],
    paymentFormInitialized: false
}
export const paymentModule = {
    state: () => ({
        payment: {...PAYMENT_STATE}
    }),
    getters: paymentGetters,
    mutations: paymentMutations
}

